import React from 'react';

import styles from './carsBookmarkCounterWrapper.module.scss'

const carsBookmarkCounterWrapper = props => {
  return (
    <div className={styles.carsBookmarkCounterWrapper}>
      {props.children}
    </div>
  )
}

export default carsBookmarkCounterWrapper